/*
 * File: main.ts
 * Project: rast-app
 * Create Date: Tuesday, 15th July 2025
 * Author: Pedro Santos (pedro.santos@vonbraunlabs.com)
 * -----
 * Last Modified: Thursday, 12th March 2026 10:34:59 pm
 * Modified by: Pedro Santos (pedro.santos@vonbraunlabs.com)
 * -----
 * Copyright (c) 2026 CPA Wernher von Braun
 * ----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	---------------------------------------------------------
 */

import { bootstrapApplication } from '@angular/platform-browser';
import { RouteReuseStrategy, provideRouter } from '@angular/router';
import { provideIonicAngular, IonicRouteStrategy, Platform } from '@ionic/angular/standalone';

import { routes } from '@routes';
import { AppComponent } from './app/app.component';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { importProvidersFrom, inject, provideAppInitializer } from '@angular/core';
import { JwtModule } from '@auth0/angular-jwt';
import { authInterceptor, refreshTokenInterceptor } from '@interceptors';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import { BiometricAuthService } from './app/core/services/biometric-auth/biometric-auth.service';

bootstrapApplication(AppComponent, {
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular({
      backButtonIcon: 'chevron-back-outline',
    }),
    provideHttpClient(withInterceptors([refreshTokenInterceptor, authInterceptor])),
    provideRouter(routes),
    importProvidersFrom(
      JwtModule.forRoot({})
    ),
    provideEnvironmentNgxMask(),
    provideAppInitializer(async () => {
      try {
        const platform = inject(Platform);
        if (!platform.is('capacitor')) return;

        const biometricAuthService = inject(BiometricAuthService);
        if (await biometricAuthService.isEnabled()) {
          localStorage.removeItem('accessToken');
          localStorage.removeItem('refreshToken');
        }
      } catch {
        // Gate de biometria no cold start é best-effort: nunca deve
        // impedir o app de inicializar.
      }
    })
  ],
}).catch(err => console.error(err));

defineCustomElements(window);
